export const isBackendUnavailable = (error) => {
  if (!error) {
    return false;
  }

  if (!error.response) {
    return true;
  }

  return error.response.status >= 500;
};
